export const AboutProfile = (props = {}) => {
  let company = props.company || {};

  const profiles = [
    {
      title: "会社名",
      body: "株式会社トッカシステムズ",
    },
    {
      title: "所在地",
      body: "101-0051<br>東京都千代田区神田神保町2-20　ワカヤギビル3階",
    },
    {
      title: "電話番号",
      body: "03-5213-4278",
    },
    {
      title: "FAX",
      body: "03-5213-4279",
    },
    {
      title: "メール",
      body: "info@tocca-net.jp",
    },
    {
      title: "website",
      body: "https://tocca.systems",
    },
    {
      title: "設立年月日",
      body: "2008年2月",
    },
    {
      title: "資本金",
      body: "10,000千円",
    },
    {
      title: "役員",
      sub: [
        {
          name: "代表取締役　谷 樹",
        },
        {
          name: "取締役　吉田 恒",
        },
      ],
    },
    {
      title: "従業員数",
      body: company.employeeNum,
    },
    {
      title: "所属団体",
      body: "東京商工会議所　公益社団法人 神田法人会",
    },
    {
      title: "パートナー",
      title_sub: "（販売代理店契約）",
      sub: [
        {
          name: "ハートコア株式会社",
        },
        {
          name: "株式会社クオリティア",
        },
        {
          name: "株式会社アイロバ",
        },
        {
          name: "日本ヒューレット・パッカード株式会社",
          add: "（Hewlett-Packard Japan, Ltd.）",
        },
        {
          name: "株式会社日本HP",
          add: "（HP Japan Inc.）",
        },
        {
          name: "GMOデジタルラボ株式会社",
        },
        {
          name: "株式会社microCMS",
        },
      ],
    },
    {
      title: "事業内容",
      sub: [
        {
          name: "システムコンサルティング",
        },
        {
          name: "システム開発",
        },
        {
          name: "システム構築",
        },
        {
          name: "Web制作",
        },
        {
          name: "スマートフォンアプリ開発",
        },
        {
          name: "インターネットメディアサービス",
        },
      ],
    },
    {
      title: "認証・資格",
      sub: [
        {
          name: "QMS",
          add: "（ISO9001）",
        },
        {
          name: "ISMS",
          add: "（ISO/IEC 27001）",
        },
        {
          add: "※認証機関：J-VAC 2016年5月取得",
        },
      ],
    },
  ];

  return (
    <div id="profile" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl space-y-2 px-6 sm:px-8 md:space-y-8 md:px-12 xl:px-0">
        <div className="relative z-10">
          <h3 className="font-bold text-ter fluid-text-[16px,18px]">
            Corporate Profile
          </h3>
        </div>
        <div className="flex flex-col divide-y divide-solid divide-bdc-light border-x-0 border-y border-solid border-bdc-light">
          {profiles.map((profile) => (
            <dl
              className="grid grid-cols-1 items-center space-y-1 border-x-0 py-2 md:grid-cols-4 md:py-4"
              key={profile.index}
            >
              <dt className="col-span-1 font-bold leading-snug text-pri fluid-text-[12px,16px]">
                {profile.title}
                {profile.title_sub && (
                  <span className="block font-normal text-txt-light fluid-text-[10px,14px]">
                    {profile.title_sub}
                  </span>
                )}
              </dt>
              <dd className="col-span-3 leading-snug text-txt-base fluid-text-[14px,18px]">
                {profile.body && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${profile.body}`,
                    }}
                  />
                )}
                <div>
                  {profile.sub && (
                    <ul className="">
                      {profile.sub.map(function (item) {
                        return (
                          <li key="{item.index}" className="">
                            {item.name}
                            <span className="ml-2 font-normal text-txt-light fluid-text-[10px,14px]">
                              {item.add}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              </dd>
            </dl>
          ))}
        </div>
      </div>
    </div>
  );
};
